import { useNavigate, useParams } from "react-router-dom";
import { useInsightsCtx } from "./InsightsLayout";
import UnitEventsTable from "./unitEventsTable";
import Spinner from "../../components/ui/Spinner";
import ErrorState from "../../components/ui/ErrorState";

export default function SensorsPage() {
  const { buildingId = "" } = useParams();
  const navigate = useNavigate();
  const { buildings, buildingsLoading, startDate, endDate, searchQuery } =
    useInsightsCtx();

  if (buildingsLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner size={96} />
      </div>
    );
  }

  const building = buildings.find((b) => b.buildingId === buildingId);
  if (!building) {
    return (
      <ErrorState
        title="Property not found"
        message="We couldn't find a property matching this URL."
        onRetry={() => navigate("/insights")}
      />
    );
  }

  return (
    <UnitEventsTable
      building={building}
      startDate={startDate}
      endDate={endDate}
      searchQuery={searchQuery}
      onSensorClick={(sensor: { name: string }) =>
        navigate(
          `/insights/properties/${buildingId}/sensors/${encodeURIComponent(
            sensor.name
          )}`
        )
      }
    />
  );
}
